import React,{useState} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const ModalPopup = () => {

    const [show, setShow] = useState(true);

  return (
    <div>
      <Modal show={show}>
        <Modal.Header style={{margin: "20px 0px"}}>
          <Modal.Title>Please Login</Modal.Title>
        </Modal.Header>
      </Modal>
    </div>
  );
};
